<template>
  <div v-if="isToday">
    <translate class="msg"> Your holiday starts today! </translate>
  </div>
  <time
    v-else
    :datetime="date"
    class="time-until-holiday"
    :class="{ desktop: $isDesktop }"
  >
    <translate tag="div" class="msg" :tt="{ [until.unit]: until.value }">
      Only {{ until.unit }} until your holiday
    </translate>
  </time>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { daysBetween, timeBetween } from '~/utility/date/relative'

@Component
class BookingTimeUntilHoliday extends Vue {
  @Prop({ required: true })
  date: string

  get isToday() {
    return daysBetween(new Date(), this.date) === 0
  }

  get until() {
    return timeBetween(new Date().toISOString(), this.date)
  }
}

export default toNative(BookingTimeUntilHoliday)
</script>

<style scoped>
time {
  display: block;
}

.msg {
  display: inline-flex;
  font-size: var(--small);
  font-weight: 500;
}

.time-until-holiday .msg {
  text-wrap-style: auto;
  line-height: 1.1;
  padding: 0;
  font-weight: 400;
  color: var(--colour-price);
  text-wrap-style: balance;
  /* for those that support it */
  text-wrap-style: pretty;
}
</style>
